import React, { FC } from 'react'
import { DeleteOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import { useShopping } from '../hooks'

interface SummaryButtonProps {
  productId: string
}

export const SummaryButton: FC<SummaryButtonProps> = ({
  productId
}) => {
  const { chart, setChart } = useShopping()

  return (<Space.Compact 
    size='small'
    style={{
      textAlign: 'center'
  }}>
    <Button 
      size='small'
      type='primary'
      style={{
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8
      }}
      onClick={() => {
        setChart(prev => ({
          ...prev,
          [productId]: {
            ...prev[productId],
            quantity: (prev[productId]?.quantity || 0) - 1
          }
        }))
      }}
      icon={productId in chart && chart[productId]?.quantity > 1 
        ? <MinusOutlined /> 
        : <DeleteOutlined />}
    />
    <Button 
      type='primary'
      style={{
        minWidth: 40,
        pointerEvents: 'none',
        cursor: 'default'
      }}>{chart[productId]?.quantity || 0}</Button>
    <Button 
      size='small'
      type='primary'
      onClick={() => {
        setChart(prev => ({
          ...prev,
          [productId]: {
            ...prev[productId],
            quantity: (prev[productId]?.quantity || 0) + 1
          }
        }))
      }}
      style={{
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8
      }}
      icon={<PlusOutlined />}
    />
  </Space.Compact>)
}
